import axios from "axios";
import React, { useState, useEffect } from "react";
import moment from "moment";
import ReportsCriteria from "../../ShortCutComponents/ReportsCriteria";
import { baseurl } from "../../../../baseurl";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "./formsTable.css";
import "./baseForms.css";
import ExportToExcel from "../../SExport/ExportToExcle";
import { Button, Collapse, Table } from "reactstrap";
import swal from "@sweetalert/with-react";
import { generateCriteriaString } from "../../ShortFunction/shortFunctions";


let companyId = localStorage.getItem("companyId");
let username = localStorage.getItem("username");
var token = localStorage.getItem("token");
var companySymbolCurrency = localStorage.getItem("companySymbolCurrency");

function due_Formators(cell, row, enumObject, index) {
  if (cell === null || cell === undefined || cell === "") {
    return "";
  }

  if (typeof cell === "string") {
    return cell;
  }

  if (typeof cell === "number") {
    return cell.toLocaleString("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  }

  return String(cell);
}

function formatWithDrCr(amount) {
  const numAmount = Number(amount);
  const formattedAmount = Math.abs(numAmount).toLocaleString("en-US", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });

  if (numAmount > 0) {
    return `${formattedAmount} Dr`;
  } else if (numAmount < 0) {
    return `${formattedAmount} Cr`;
  } else {
    return `${formattedAmount}`;
  }
}

export default function AllsuppliersReport(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [showtable, setshowtable] = useState(false);

  const [data, setData] = useState({
    criteriaString: "All",
    collapseCriteria: true,
  });

  const [table, setTable] = useState({
    OverViewDataTable: [],
    printData: [],
    listOfData: [],
    listOfColLables: [],
    listOfColKey: [],
    exportData: [],
    totalSumAll: null,
  });

  const [filteredData, setFilteredData] = useState([]);

  // Define columns array
  const columns = [
    // {
    //   dataField: "sr",
    //   text: "Sr#",
    //   sort: true,
    //   footer: "Total",
    //   style: {
    //     textAlign: "left",
    //     fontWeight: "bold",
    //     backgroundColor: "#f8f9fa",
    //   },
    //   footerStyle: {
    //     textAlign: "left",
    //     fontWeight: "bold",
    //   },
    // },
    {
      dataField: "supplier_code",
      text: "Supplier Code",
      sort: true,
      footer: "Total",
      style: {
        textAlign: "left",
        backgroundColor: "#f8f9fa",
      },
      footerStyle: {
        textAlign: "left",
      },
    },
    {
      dataField: "company_name",
      text: "Supplier Name",
      sort: true,
      footer: "-",
      style: {
        textAlign: "left",
        backgroundColor: "#f8f9fa",
      },
      footerStyle: {
        textAlign: "left",
      },
    },
    {
      dataField: "opening",
      text: "Opening",
      sort: true,
            headerStyle: {
    textAlign: "right",  
  },
      formatter: (cell) => formatWithDrCr(cell),
      footer: () =>
        table.totalSumAll
          ? formatWithDrCr(table.totalSumAll.opening)
          : "0.00",
      style: {
        textAlign: "right",
        backgroundColor: "#f8f9fa",
      },
      footerStyle: {
        fontWeight: "bold",
        textAlign: "right",
      },
    },
    {
      dataField: "Debit",
      text: "Debit",
      sort: true,
      formatter: due_Formators,
            headerStyle: {
    textAlign: "right",  
  },
      footer: () =>
        table.totalSumAll ? due_Formators(table.totalSumAll.Debit) : "0.00",
      style: {
        textAlign: "right",
        backgroundColor: "#f8f9fa",
      },
      footerStyle: {
        fontWeight: "bold",
        textAlign: "right",
      },
    },
    {
      dataField: "Credit",
      text: "Credit",
      sort: true,
      formatter: due_Formators,
            headerStyle: {
    textAlign: "right",  
  },
      footer: () =>
        table.totalSumAll
          ? due_Formators(table.totalSumAll.Credit)
          : "0.00",
      style: {
        textAlign: "right",
        backgroundColor: "#f8f9fa",
      },
      footerStyle: {
        fontWeight: "bold",
        textAlign: "right",
      },
    },
    {
      dataField: "closing",
      text: "Closing",
            headerStyle: {
    textAlign: "right",  
  },
      sort: true,
      formatter: (cell) => formatWithDrCr(cell),
      footer: () =>
        table.totalSumAll
          ? formatWithDrCr(table.totalSumAll.closing)
          : "0.00",
      style: {
        textAlign: "right",
        backgroundColor: "#f8f9fa",
      },
      footerStyle: {
        fontWeight: "bold",
        textAlign: "right",
      },
    },
  ];

//   useEffect(() => {
//     const funCall = async () => {
//       getAccountsSummary();
//     };
//     funCall();
//   }, []);

  const getAccountsSummary = async (
    fromDate,
    toDate,
    supplier_id,
    supplier_id2,
    branch_id,
    suppType_id,
  ) => {
    setIsLoading(true);
    try {
      const fDate = fromDate ? moment(fromDate).format("YYYY-MM-DD") : null;
      const tDate = toDate ? moment(toDate).format("YYYY-MM-DD") : null;
      const response = await axios.post(
        `${baseurl}/repots/supplierGLReportsummary`,
        {
          fromDate: fDate,
          toDate: tDate,
          supplier_id: supplier_id?.code,
          supplier_id2: supplier_id2?.code,
          multiPosBranch: branch_id?.id,
          suppType_id : suppType_id || suppType_id.id || null,
          username,
          companyId,
        },
        {
          headers: { authorization: token },
        },
      );
      const callData = response.data.data;
      processTableData(
        callData,
        fromDate,
        toDate,
        supplier_id,
        supplier_id2,
        branch_id,
      );
    } catch (error) {
      console.error("Error fetching suppliers report:", error);
      setIsLoading(false);
    }
  };

  const processTableData = (
    callData,
    fromDate,
    toDate,
    supplier_id,
    supplier_id2,
    branch_id
  ) => {
    let mainScreenData = [];
    let printData = [];
    let exportData = [];
  // 👇 ye header row add karein
const headers = {
  supplier_code: "Supplier Code",
  company_name: "Supplier Name",
  opening: "Opening",
  Debit: "Debit",
  Credit: "Credit",
  closing: "Closing",
} ;
    callData.forEach((element, index) => {
      const Credit = Number(element.Credit) || 0;
      const Debit = Number(element.Debit) || 0;
      const opening = Number(element.opening) || 0;
      const closing = (opening + Debit) - Credit;
  
      const rowData = {
        // sr: index + 1,
        supplier_code: element.supplier_code ||  "",
        company_name: element.company_name ||  "",
        opening: opening,
        Debit: Debit,
        Credit: Credit,
        closing: closing,
      };
  
      mainScreenData.push(rowData);
  
      printData.push({
        // sr: rowData.sr,
        supplier_code: rowData.supplier_code,
        company_name: rowData.company_name,
        opening: formatWithDrCr(opening),
        Debit: due_Formators(Debit),
        Credit: due_Formators(Credit),
        closing: formatWithDrCr(closing),
      });
    });
  
    const totalSumAll = mainScreenData.reduce(
      (acc, curr) => ({
        opening: acc.opening + curr.opening,
        Debit: acc.Debit + curr.Debit,
        Credit: acc.Credit + curr.Credit,
        closing: acc.closing + curr.closing,
      }),
      {
        opening: 0,
        Debit: 0,
        Credit: 0,
        closing: 0,
      }
    );
  
    printData.push({
    //   sr: "Total",
      supplier_code: "ToTal",
      company_name: "",
      opening: formatWithDrCr(totalSumAll.opening),
      Debit: due_Formators(totalSumAll.Debit),
      Credit: due_Formators(totalSumAll.Credit),
      closing: formatWithDrCr(totalSumAll.closing),
    });
  
    exportData = [...printData];
  // NAUMAN SALEEM's REQUEST
const listOfColLables = [
  { align: "center", value: "Supplier Code" },
  { align: "center", value: "Supplier Name" },
  { align: "center", value: "Opening" },
  { align: "center", value: "Debit" },
  { align: "center", value: "Credit" },
  { align: "center", value: "Closing" },
];

  
    const listOfColKey = [
    //   { align: "left", value: "sr" },
      { align: "left", value: "supplier_code" },
      { align: "left", value: "company_name" },
      { align: "right", value: "opening" },
      { align: "right", value: "Debit" },
      { align: "right", value: "Credit" },
      { align: "right", value: "closing" },
    ];
  exportData.unshift(headers);
    setTable({
      OverViewDataTable: mainScreenData,
      printData,
      listOfData: exportData,
      listOfColLables,
      listOfColKey : listOfColKey,
      exportData,
      totalSumAll: totalSumAll,
      selectedStartDate: fromDate,
      selectedendDate: toDate,
      selectedSupplier: supplier_id?.label || "All",
      selectedSupplier2: supplier_id2?.label || "All",
      selectedBranch: branch_id?.label || "All",
    });

    setFilteredData(mainScreenData);
    setIsLoading(false);
  };

  const handleFind = (p) => {
    const { fromDate, toDate, supplier_id, supplier_id2, branch_id , suppType_id} = p;
    console.log("p", p);

    const critObj = {
      fromDate,
      toDate,
      supplier_id,
      supplier_id2,
      branch_id,
      multiSuppLabel: supplier_id?.label,
      multiSupp2Label: supplier_id2?.label,
      multiPosBranchLabel: branch_id?.label,
      multiPosBranch: branch_id,
    };

    const criteriaString = generateCriteriaString(critObj);

    setData({
      ...data,
      criteriaString: criteriaString,
    });

    console.log("criteriaString :>> ", criteriaString);
    console.log("p :>> ", p);
    
if (!fromDate || !toDate) {
  const missingField = !fromDate ? "From Date" : "To Date";

  swal({
    title: `Missing ${missingField}`,
    text: `Please select a ${missingField} before continuing.`,
    icon: "warning",
    timer: 2000,
    buttons: false,
  });
  return;
}
    setshowtable(true);

    getAccountsSummary(
      fromDate,
      toDate,
      supplier_id,
      supplier_id2,
      branch_id,
      suppType_id,
    );
  };

  const handleDynamicColapse = (params) => {
    setData((prev) => ({ ...prev, collapseCriteria: params.collapseCriteria }));
  };

  const sendSearchedData = (params) => {
    setFilteredData(params.filteredData);
  };

  const funPrintView = (data1, headers, headerKeyMap) => {
    const {
      selectedStartDate,
      selectedendDate,
      selectedSupplier,
      selectedSupplier2,
    } = table;

    let fromDatee = selectedStartDate
      ? moment(selectedStartDate).format("DD-MMM-YYYY")
      : "All";
    let toDatee = selectedendDate
      ? moment(selectedendDate).format("DD-MMM-YYYY")
      : "All";
    let dateCriteria = [
      { label: "From Date", value: fromDatee },
      { label: "To Date", value: toDatee }
    ];

    let criteria = [
      dateCriteria[0],
      dateCriteria[1],
      { label: "From Supplier", value: selectedSupplier },
      { label: "To Supplier", value: selectedSupplier2 },      
    ];

    console.log("criteria :>> ", criteria);

    props.history.push({
      pathname: "/PrintReports",
      state: {
        data: data1,
        headers: headers,
        headerKeyMap: headerKeyMap,
        goBackUrl: "/SupplierGLreport",
        dynamicInvMessage: "Supplier Balances GL Report",
        reportName: "Supplier_Balances_GL_Report",
        criteria,
        criteriaString: data.criteriaString,
      },
    });
  };

  const graph = () => {
    swal({
      title: "Coming Soon",
      text: "This feature is under development",
      icon: "warning",
      timer: 2000,
      buttons: false,
    });
  };

  const options = {
    paginationShowsTotal: true,
    page: 1,
    sizePerPage: 10,
    pageStartIndex: 1,
    paginationSize: 5,
    prePage: "Prev",
    nextPage: "Next",
    firstPage: "First",
    lastPage: "Last",
    prePageTitle: "Go to previous",
    nextPageTitle: "Go to next",
    firstPageTitle: "Go to first",
    lastPageTitle: "Go to Last",
    sizePerPageList: [
      { text: "10", value: 10 },
      { text: "30", value: 30 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "All", value: filteredData?.length || 100 },
    ],
    custom: true,
  };


  return (
    <>
      <div className="position-relative">
        <div
          className={`container-fluid bg-white ${
            isLoading ? "blur-background" : ""
          }`}
        >
          <ReportsCriteria
            reportName="Supplier Balances GL Report"
            lovs={["fromDate", "toDate", "fromSupp", "toSupp", "suppType","branch"]}
            isMulti={false}
            companyId={companyId}
            token={token}
            callBack={handleDynamicColapse}
            username={username}
            handleFind={(p) => handleFind(p)}
            table={table.OverViewDataTable}
            sendSearchedData={sendSearchedData}
            todaysDate={true}
          />

          <Collapse isOpen={data.collapseCriteria}>
            <div className="row float-right pr-4 mb-2">
              <Button
                color="secondary"
                className="button-22"
                onClick={() => graph()}
                id="invoiceButton"
              >
                Graph
              </Button>
              <Button
                color="success"
                className="button-22 "
                onClick={() =>
                  funPrintView(
                    table.printData,
                    table.listOfColLables,
                    table.listOfColKey
                  )
                }
                id="invoiceButton"
              >
                Print
              </Button>

                <ExportToExcel
                  Data={table.exportData}
                  listOfColKey={table.listOfColKey}
                  DynamicReports={true}
                  ReportName="Supplier Balances GL Report"
                  criteriaString={data.criteriaString}
                />
            </div>
          </Collapse>
          {showtable && (
            <div translate="no" className="mt-5">
              <div className="sticky-table-wrapper">
                <div className="sticky-table-container">
                  <PaginationProvider pagination={paginationFactory(options)}>
                    {({ paginationProps, paginationTableProps }) => (
                      <div>
                        {/* TOP Pagination Controls */}
                        <div className="d-flex justify-content-between align-items-center my-2">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                        </div>

                        <BootstrapTable
                          keyField="sr"
                          data={filteredData}
                          columns={columns}
                          headerClasses="rpr_header"
                          bodyClasses="rpr_body"
                          containerClass="rpr_container"
                          striped
                          condensed
                          hover
                          {...paginationTableProps}
                        />
                      </div>
                    )}
                  </PaginationProvider>
                </div>
              </div>
            </div>
          )}
        </div>
        {isLoading && (
          <div className="loader-overlay">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}
      </div>
    </>
  );
}